import {Component, Input} from '@angular/core';
import {PrlLanguageModule} from '../../../../prl-language/prl-language.module';
import {MxSharedModule} from 'mx-core';

@Component({
  selector: 'prl-balance-item',
  imports: [
    PrlLanguageModule,
    MxSharedModule
  ],
  templateUrl: './balance-item.component.html',
  styleUrl: './balance-item.component.css',
})
export class BalanceItemComponent {
    @Input() label: string;
    @Input() value: string;
}
